import { createRouter, createWebHistory } from "vue-router";
import AlertsTable from "./components/alerts/AlertsTable.vue";
import AlertDetails from "./components/alerts/AlertDetails.vue";
import Login from "./components/Login.vue";
import store from "./store";

const routes = [
  { path: "/login", name: "Login", component: Login, meta: { public: true } },
  { path: "/", name: "Alerts", component: AlertsTable, meta: { requiresAuth: true } },
  {
    path: "/alert/:identifier",
    name: "AlertDetails",
    component: AlertDetails,
    props: true,
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.state.isAuthenticated;
  if (to.meta.requiresAuth && !isAuthenticated) {
    return next({ name: "Login", query: { redirect: to.fullPath } });
  }
  if (to.name === "Login" && isAuthenticated) {
    return next({ name: "Alerts" });
  }
  next();
});

export default router;
